export default "__VITE_ASSET__223ad121__"